import { EventEmitter } from 'eventemitter3';
import Worker from 'web-worker';
import { createWorker } from '../../utils/workerUtils';
export class AudioDecoderWrapper extends EventEmitter {
    worker;
    audioDecoder;
    constructor() {
        console.log('AudioDecoderWrapper constructor');
        super();
    }
    decode(audioFrames) {
        for (const frame of audioFrames) {
            if (this.worker) {
                // Intentionally copy the data. The data cannot be moved to the worker because Streamr Network will
                // still propagate it to the neighbors after this call.
                this.worker.postMessage({
                    type: 'decode',
                    data: frame,
                });
            }
            else {
                this.audioDecoder?.decode(frame);
            }
        }
    }
    onDecodedAudioData(audioData) {
        this.emit('audioData', audioData);
    }
    startAudioDecoderWorker() {
        return new Promise((resolve, _reject) => {
            // Not DRY, but otherwise webpack won't transform the worker url
            if (process.env.BUILD_TRANSFORMS_FILENAMES) {
                this.worker = new Worker(new URL('./workers/audiodecoder.worker.ts', import.meta.url));
            }
            else {
                this.worker = createWorker('./workers/audiodecoder.worker.js', import.meta.url);
            }
            this.worker.onmessage = (e) => {
                const { type } = e.data;
                switch (type) {
                    case 'audioData':
                        this.onDecodedAudioData(e.data.data);
                        break;
                    case 'initCompleted':
                        resolve();
                        break;
                }
            };
            this.worker.postMessage({
                type: 'init',
            });
        });
    }
    async init() {
        try {
            await this.startAudioDecoderWorker();
        }
        catch (_e) {
            console.error('AudioDecoder is not supported, stopping');
        }
    }
}
